import PropTypes from "prop-types";
import { digitalData } from "@lululemon/ecom-site-utils";
import { handleDynamicImportError } from "@lululemon/ecom-site-utils/src/logger/utils";
import dynamic from "next/dynamic";
import { useWebStrings } from "@lululemon/ecom-contentful";
import { genericErrorModalKeys } from "../../utils/contentful-keys";

import styles from "./generic-error-modal.module.scss";

const DynamicModal = dynamic(
  () =>
    import("./generic-error-modal-loader").catch(() =>
      handleDynamicImportError("DynamicModal", "GenericErrorModal")
    ),

  {
    ssr: false
  }
);

const refreshPage = () => {
  digitalData.clearErrorData();
  if (window) {
    window.location.assign(window.location.href);
  }
};

const GenericErrorModal = ({ displayGenericErrorModal }) => {
  const microcopy = useWebStrings(genericErrorModalKeys);

  if (!displayGenericErrorModal) {
    return undefined;
  }

  const closeButtonLabel = microcopy?.["mybag.generic-error-modal.close-label"];

  return (
    <DynamicModal
      visible
      messages={{ close: closeButtonLabel }}
      onRequestClose={refreshPage}
      title={microcopy.mybag_genericError_modal_header}
      titleId="generic-error-modal"
      primaryCta={{
        children: microcopy.mybag_genericError_primary_CTA,
        variant: "filledImpact",
        onClick: refreshPage,
        "data-lulu-track": "my-bag-generic-error-modal-refresh"
      }}
      cancelProps={{
        "data-lulu-track": "my-bag-generic-error-modal-cancel"
      }}
      classes={{
        modal: "OneLinkNoTx",
        modalContent: styles.center,
        heading: styles.center
      }}
    >
      <p className={styles.whiteSpace}>
        {microcopy.mybag_genericError_modal_desc}
      </p>
    </DynamicModal>
  );
};

GenericErrorModal.propTypes = {
  displayGenericErrorModal: PropTypes.bool
};

GenericErrorModal.defaultProps = {
  displayGenericErrorModal: false
};

export default GenericErrorModal;
